import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Modal } from "react-bootstrap";
import styled from "styled-components";
import { Button } from "../ButtonElements";
import PropTypes from "prop-types";

const StyledModal = styled(Modal)`
  .modal-backdrop {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1 !important;
  }

  .modal-dialog {
    max-width: 80%;
    margin: 1.75rem auto;

    @media (min-width: 576px) {
      max-width: 400px;
    }
  }

  .modal-content {
    background: linear-gradient(135deg, #1e1e1e, #121212);
    border-radius: 15px;
    color: white;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  .modal-header {
    border-bottom: none;
    justify-content: center;
    padding: 15px;
  }

  .modal-title {
    width: 100%;
    text-align: center;
    font-size: 18px;
  }

  .btn-close {
    position: absolute;
    right: 15px;
    top: 15px;
    background: none;
    opacity: 0.7;
    color: white;
    font-size: 20px;

    &:hover {
      opacity: 1;
    }
  }
`;

const QRContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;

  @media (min-width: 576px) {
    flex-direction: row;
    justify-content: center;
    gap: 30px;
  }
`;

const QRColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 200px;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }

  img {
    max-width: 150px;
    width: 100%;
    height: auto;
  }
`;

const QRWrapper = styled.div`
  width: 150px;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const QRCodeTitle = styled.p`
  margin-top: 10px;
  font-size: 12px;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const ExternalLinkModal = ({ show, onHide, t, primary, dark, dark2 }) => (
  <StyledModal show={show} onHide={onHide} centered backdrop={true}>
    <Modal.Header>
      <Modal.Title>{t("signup.qrcodeModalHeader")}</Modal.Title>
      <button
        type="button"
        className="btn-close"
        aria-label="Close"
        onClick={onHide}
      >
        ×
      </button>
    </Modal.Header>
    <Modal.Body>
      <QRContainer>
        <QRColumn>
          <QRWrapper>
            <QRCodeCanvas
              value="https://play.google.com/store/apps/details?id=com.CliClaim.Client"
              size={150}
              fgColor="white"
              bgColor="transparent"
              level={"H"}
              imageSettings={{
                src: require("../../images/favicon.ico"),
                height: 30,
                width: 30,
                excavate: true,
              }}
            />
          </QRWrapper>
          <QRCodeTitle>Google Play</QRCodeTitle>
          <a
            href="https://play.google.com/store/apps/details?id=com.CliClaim.Client"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
              alt="Google Play"
              style={{ width: "150px", height: "50px", objectFit: "contain" }}
            />
          </a>
        </QRColumn>

        <QRColumn>
          <QRWrapper>
            <QRCodeCanvas
              value="https://apps.apple.com/tn/app/cliclaim-client/id6749679124?l=fr-FR"
              size={150}
              fgColor="white"
              bgColor="transparent"
              imageSettings={{
                src: require("../../images/favicon.ico"),
                height: 30,
                width: 30,
                excavate: true,
              }}
            />
          </QRWrapper>
          <QRCodeTitle>App Store</QRCodeTitle>
          <a
            href="https://apps.apple.com/tn/app/cliclaim-client/id6749679124?l=fr-FR"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
              alt="App Store"
              style={{ width: "150px", height: "50px", objectFit: "contain" }}
            />
          </a>
        </QRColumn>
      </QRContainer>

      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <Button
          as="a"
          href="https://customer.cliclaim.com/"
          target="_blank"
          rel="noopener noreferrer"
          primary={primary ? 1 : 0}
          dark={dark ? 1 : 0}
          dark2={dark2 ? 1 : 0}
        >
          {t("signup.externallink")}
        </Button>
      </div>
    </Modal.Body>
  </StyledModal>
);

ExternalLinkModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  primary: PropTypes.bool,
  dark: PropTypes.bool,
  dark2: PropTypes.bool,
};

ExternalLinkModal.defaultProps = {
  primary: false,
  dark: false,
  dark2: false,
};

export default ExternalLinkModal;
